module.exports = require('./lib/McFly');


/*****************
 ** WEBPACK FOOTER
 ** ./~/mcfly/index.js
 ** module id = 18
 ** module chunks = 0
 **/